import React, { Component } from 'react';
import { message, Table, Input, Select, Modal, Button, DatePicker } from 'antd';
import { getSettleOrder, getServicerList, } from '../../services/analysisCenter';
import ManegerModal from '../../components/managerModal/index.jsx';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/zh_CN';
import 'moment/locale/zh-cn';

const dateForm = 'YYYY-MM-DD';
const monthAgo = moment(new Date()).subtract(31, 'days').format(dateForm);
const today = moment(new Date()).format(dateForm);

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      info: {
        service: 0,
        serviceName: '全部',
        start: monthAgo,
        end: today,
      },
      data: [],
      count: 0,
    };
    this.manegerModal = React.createRef();
    this.columns = [
      {
        title: '客服名称',
        dataIndex: 'name',
        align: 'center',
        width: 100,
      },
      {
        title: '整理数量',
        dataIndex: 'collect',
        align: 'center',
        width: 100,
      },
    ];
  }
  componentDidMount() {
    this.getList()
  }
  render() {
    const { info, data, count } = this.state;
    return (
      <div>
        <div className='bar row-l'>
          <div>选择客服：</div>
          <div className='w200 bord3 h32 tc fz14'>
            {info.serviceName}
          </div>
          <Button onClick={this.showManager} type='primary'>选择</Button>
          <div className='margin-l20'>时间范围：</div>
          <DatePicker.RangePicker value={[moment(info.start), moment(info.end)]}
            onChange={this.changeInfo.bind(this, 'times')} locale={locale} allowClear={false} />
          <Button onClick={this.getList} type='primary'>搜索</Button>
          <div className='margin-l20 fz16 bold'>合计：{count}</div>
        </div>
        <div className='bar'>
          <Table
            columns={this.columns}
            dataSource={data}
            size={'small'}
            rowKey={record => record.id}
            bordered
            pagination={false}
          // pagination={{ defaultPageSize: 20 }}
          />
        </div>
        <ManegerModal
          ref={this.manegerModal}
          selectManager={this.selectManager}
        />
      </div>
    );
  }

  //客服
  showManager = () => {
    this.manegerModal.current.onShow(false);
  }
  selectManager = (e) => {
    let info = { ...this.state.info };
    info.service = e[0].id;
    info.serviceName = e[0].name;
    this.setState({
      info,
    })
  }
  changeInfo = (type, e) => {
    let info = { ...this.state.info };
    switch (type) {
      case 'service':
        info[type] = e;
        break;
      case 'times':
        info.start = moment(e[0]).format(dateForm);
        info.end = moment(e[1]).format(dateForm);
        break;
    }
    this.setState({
      info,
    })
  }
  getList = async () => {
    const { info } = this.state;
    let res = await getSettleOrder(info.service, info.start, info.end);
    let count = 0;
    if (res.status === 200) {
      let data = [];
      res.data.map(item => {
        let local = data.findIndex(r => r.name === item.name);
        if (local < 0) {
          data.push(item);
        } else {
          data[local].collect += item.collect;
          data[local].day = item.day;
        }
      });
      let data3 = [];
      let data4 = [];
      let sort = [
        '数据一号', '数据二号', '数据三号', '数据四号', '数据五号', '数据六号', '数据七号', '数据八号', '数据九号', '数据十号',
        '数据十一号', '数据十二号', '数据十三号', '数据十四号', '数据十五号', '数据十六号', '数据十七号', '数据十八号', '数据十九号', '数据二十号',
        '数据二十一号', '数据二十二号', '数据二十三号', '数据二十四号', '数据二十五号', '数据二十六号', '数据二十七号', '数据二十八号', '数据二十九号', '数据三十号',
      ];
      let newData = data.filter(r => r.name.includes('数据'));
      for (let i = newData.length; i--; i < 0) {
        let exit = false;
        sort.map((item, index) => {
          if (newData[i].name.includes(item)) {
            if (data3[index]) {
              exit = false;
            } else {
              data3[index] = newData[i];
              exit = true;
            }
          }

        });
        if (!exit) {
          data4.push(newData[i])
        }
      }
      data3 = data3.filter(r => r).concat(data4);
      data3.map(item => {
        count += item.collect;
      })
      this.setState({
        data: data3, count
      });
    }
  }
}
export default Index;
